module.exports = __webpack_public_path__ + "static/media/systemAnnouncement.a69ee9c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/systemAnnouncement.svg
// module id = 438
// module chunks = 0